
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const moduleModal = {
  state: {
    active: false,
    error: '',
    component: '',      //komponento pavadinimas jis bus automatiskai uzkraunamas
    content: {},  // Vartotojo nuožiūra galima perduoti įvairius duomenis
  },
  mutations: {
    showConfirm (state, Data) {
      state.content = Data
      state.component = Data.customComponent 
      state.active = true
    },
    closeModal (state) {
      state.active = false
      state.content = null
    },
  },
  getters: {
    getModalActive (state) {
      return state.active
    },
    getModalContext (state) {
      if(state.content)
        return state.content.context
      else 
        return ''
    },
    getModalContent (state) {
      return state.content
    },
    getModalError (state) {
      return state.error
    },
    getModalTitle (state) {
      return state.content.title
    },
    getModalCustomComponent(state) {
      return state.component
    }
  }
}
